module.exports = __webpack_public_path__ + "media/images/projects/separation_icon-08e37538407d1d3e37a032fe72f15625.svg";